import { render } from "./search-comp.vue?vue&type=template&id=5441e1f7&scoped=true"
import script from "./search-comp.vue?vue&type=script&lang=js"
export * from "./search-comp.vue?vue&type=script&lang=js"

import "./search-comp.vue?vue&type=style&index=0&id=5441e1f7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5441e1f7"]])

export default __exports__